import React          from 'react';
import Cars           from './img/Ticketverkauf-Autos.jpg';
import CarsMobile     from './img/Mobile-Cars.jpg';
import RoxxRacingLogo from './img/Roxx-Racing-Logo.png';
import LexyFullBody   from './img/Lexy-Full-Body.png';
import VRbanner       from './img/VR-Banner.jpg';
import LogoBackground from './img/Roxx-Racing-Logo-Background.jpg';
import Logos          from './img/Logos.png';
import {AppConsumer}  from './App.context';
import ReactModal     from 'react-modal';
import styled         from 'styled-components';

let lastSeenSale = null;

ReactModal.setAppElement('#root');

class TicketsPage extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		return null;
	}
}

export default TicketsPage;




// WEBPACK FOOTER //
// ./src/TicketsPage.js